import type { UploadItem } from "./types";

export interface ItemIcon {
  name: string;
  color: string;
}

export function iconForItem(item: UploadItem): ItemIcon {
  switch (item.status) {
    case "REQUESTED":
      return { name: "mdi:circle-outline", color: "rgba(0,0,0,0.35)" };
    case "UPLOADED":
      return { name: "mdi:cloud-check-outline", color: "#5B6B61" };
    case "PROCESSING":
      return { name: "mdi:cog-outline", color: "#7C4DFF" };
    case "ACCEPTED":
      return { name: "mdi:check-circle", color: "#266A4A" };
    case "REJECTED":
      return item.error_effect === "FATAL"
        ? { name: "mdi:alert-octagon-outline", color: "#D32F2F" }
        : { name: "mdi:reload-alert", color: "#EF6C00" };
  }
}

export function stampBarColor(item: UploadItem): string | undefined {
  switch (item.status) {
    case "ACCEPTED":
      return "#266A4A";
    case "REJECTED":
      return item.error_effect === "FATAL" ? "#D32F2F" : "#EF6C00";
    default:
      return undefined;
  }
}
